import { render, staticRenderFns } from "./disbursementPayload.vue?vue&type=template&id=a1fff0ca&"
import script from "./disbursementPayload.vue?vue&type=script&lang=js&"
export * from "./disbursementPayload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports